import { useTranslation } from 'react-i18next';

interface CancelButtonProps {
  onClick: () => void;
}

export default function CancelButton({ onClick }: CancelButtonProps): JSX.Element | null {
  const { t } = useTranslation();

  return (
    <button className="btn btn-secondary btn-sm mx-1" type="button" onClick={onClick}>
      <span>{t('Views.CancelButton')}</span>
    </button>
  );
}
